/**
 * @generated SignedSource<<659f76bd2b0f26c10f2296670896eaa6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ShareholdingUpsertInputObject = {
  basisPoints: number;
  effectiveDate: any;
  note?: string | null | undefined;
  shareholderId: string;
};
export type dividendsPage_HoldingMutation$variables = {
  input: ShareholdingUpsertInputObject;
};
export type dividendsPage_HoldingMutation$data = {
  readonly shareholdingUpsert: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly shareholding: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type dividendsPage_HoldingMutation = {
  response: dividendsPage_HoldingMutation$data;
  variables: dividendsPage_HoldingMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Shareholding",
  "kind": "LinkedField",
  "name": "shareholding",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dividendsPage_HoldingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareholdingUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "shareholdingUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dividendsPage_HoldingMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ShareholdingUpsertMutationPayload",
        "kind": "LinkedField",
        "name": "shareholdingUpsert",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d7e19e8067579dccae3428328741043b",
    "id": null,
    "metadata": {},
    "name": "dividendsPage_HoldingMutation",
    "operationKind": "mutation",
    "text": "mutation dividendsPage_HoldingMutation(\n  $input: ShareholdingUpsertInputObject!\n) {\n  shareholdingUpsert(input: $input) {\n    shareholding {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "35c2ed1307bf257d0fc5753613a2dd9c";

export default node;
